import styled from 'styled-components';
import { deviceSizes, devices } from '@app/config/devices';
import { Box, Grid, OutlinedInput } from '@mui/material';

export const MaterialTableContainer = styled.div`
  ${({ hidden }) => hidden && 'display: none'}

  && {
    .MuiPaper-root {
      box-shadow: none;
      background-color: transparent;
    }
    .MuiTableRow-root {
      height: 60px !important;
    }
    .MuiTableCell-root {
      background-color: transparent;
      white-space: nowrap !important;
      //height: 120px !important;
    }
    .MuiIconButton-colorInherit {
      padding: 7px;
    }
    .MuiIconButton-colorInherit {
      color: #0D47A1;
      font-size: 10px;
    }
    .css-17ijfcn-MuiTableRow-root {
      height: 60px !important;
    }
    .css-apqrd9-MuiTableBody-root {
      background-color: #F7FBFF;
    }
    /* .MTableHeader-header-8 {
      border-left: 1px solid ${({ theme }) => theme.secondaryColor[300]};
    } */
    @media (max-width: ${deviceSizes.mobileL}) {
      .MTableToolbar-root-7 {
        flex-direction: column;
        margin-bottom: 10px;
        h6 {
          margin-bottom: 10px;
        }
      }
    }
  }
`;

export const SectionBox = styled(Box)`
  border-bottom: 1px solid ${({ theme }) => theme.secondaryColor[300]};
  margin-bottom: 1rem;
`;

export const TableToolbarContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: #fff;
  
  .MuiFormControl-root {
    margin-right: 16px;
  }
  
  @media (max-width: ${deviceSizes.mobileL}) {
    flex-direction: column;
    align-items: flex-start;
    
    .MuiFormControl-root {
      margin-right: 0;
      margin-bottom: 16px;
      width: 100%;
    }
  }
`;

export const StyledOutlinedInput = styled(OutlinedInput)`
  && {
    padding: 1rem 0.5rem;
    h6 {
      color: ${({ theme }) => theme.secondaryColor[600]};
      font-weight: 700;
    }
  }
`;

export const ExternalLink = styled.a`
  color: ${(props) => props.theme.primary.main};
  text-decoration: none;
`;

export const Section = styled(Grid)`
  .elementName {
    color: ${({ theme }) => theme.secondaryColor[600]};
  }
  .elementValue {
    color: ${({ theme }) => theme.secondaryColor[800]};
    margin-left: 1rem;
  }
  .elementSubValue {
    color: ${({ theme }) => theme.secondaryColor[200]};
    margin-left: 1rem;
  }
`;

export const StyledTitle = styled.div`
  h6 {
    padding-left: 25px;
  }
  h5 {
    // border-left: 3px solid ${({ theme }) => theme.primary.main};
    background-color: ${({ theme }) => theme.primary.navBarContent};
    color: ${({ theme }) => theme.primary.contrastText};
    padding: 10px;
    padding-left: 30px;
    width: 30rem;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-left: -6rem;
  }

  @media ${devices.xs} {
    h5 {
      width: 100%;
      margin-left: auto;
    }
  }
`;